export const enum ModuleName {
	AdminMenu = 'admin-menu',
	Agency = 'agency',
	Application = 'application',
	Article = 'article',
	AuditTrail = 'audittrail',
	Automation = 'automation',
	Binoculars = 'binoculars',
	BloggerPost = 'blogger-post',
	CalculationScheme = 'calculation-scheme',
	Candidate = 'candidate',
	CandidatePensions = 'candidate-pensions',
	CandidatePhase = 'candidate-phase',
	CandidateReservation = 'candidate-reservation',
	Cao = 'cao',
	CaoCustomAgreement = 'cao-custom-agreement',
	CaoInstance = 'cao-instance',
	CaoNews = 'cao-news',
	CaoWages = 'cao-wages',
	CaoWagesRequest = 'cao-wages-request',
	Comment = 'comment',
	Community = 'community',
	CompactView = 'mod-compact-view',
	ComponentModel = 'component-model',
	Connect = 'connect',
	Connector = 'connector',
	Contract = 'contract',
	CustomCao = 'custom-cao',
	Customer = 'customer',
	Dashboard = 'dashboard',
	Document = 'document',
	DocumentTemplate = 'document-template',
	DomainValue = 'domainvalue',
	Dossier = 'dossier',
	Employer = 'employer',
	FlexNet = 'flexnet',
	FormDesigner = 'form-designer',
	Forms = 'forms',
	Illness = 'illness',
	Invoice = 'invoice',
	Job = 'job',
	Jurisprudence = 'jurisprudence',
	Label = 'label',
	Law = 'law',
	LawNews = 'law-news',
	ModelMatrix = 'model-matrix',
	MyOrganization = 'my-organization',
	MyProfile = 'my-profile',
	News = 'news',
	NewsAdmin = 'news-admin',
	Payment = 'payment',
	Payslip = 'payslip',
	PeriodicComponents = 'periodic-components',
	Proforma = 'proforma',
	RateClass = 'rateclass',
	Role = 'role',
	Safety = 'safety',
	SalarySearch = 'salary-search',
	SavedFilter = 'savedfilter',
	Share = 'share',
	Survey = 'survey',
	SurveyAdmin = 'survey-admin',
	Tag = 'tag',
	Task = 'task',
	TextModel = 'text-model',
	Timecard = 'timecard',
	User = 'user',
	UserMenu = 'user-menu',
	Versions = 'versions',
	Wml = 'wml',
	Backoffice = 'backoffice',
	BackofficeTransferFiles = 'backofficeFiles',
}
